import plupload from 'plupload';
import { message } from 'antd';
import { environment } from '@gaodun.com/gtools';

export const randomNumber = (upper: number, lower: number, frontier = false) => {
    return Math.floor(Math.random() * (upper - lower + Number(!frontier))) + lower;
};

interface AliOssUpload {
    accessid: string;
    accesskey: string;
    host: string;
    policyBase64: string;
    signature: string;
    filename: string;
    callbackbody: string;
    expire: number;
    key: string;
    dir: string;
    g_object_name: string;
    g_object_name_type: string;
    now: number;
    timestamp: number;
    uploader: any;
    callBackResolve: any;
    env: string;
    W: any;
    browse_button?: string;
    multi_selection?: boolean;
    container?: string;
    filters?: any;
    baseUrl: string;
    filesAry: any[];
}

/**
 * @options object
 * @options.dir string 文件夹名称
 * @options.browse_button string 选择文件选择器
 * @options.multi_selection boolean 是否多张上传
 * @options.container string dom控制器选择器
 * @options.filters string 文件过滤规则
 * @options.filenameType string 上传文件命名规则 --- local_name: 本地名; random_name： 随机名称
 */
interface AliOssUploadOptions {
    dir: string;
    browse_button?: string;
    multi_selection?: boolean;
    container?: string;
    filters?: any;
    filenameType?: string;
}

class AliOssUpload {
    constructor(options: AliOssUploadOptions) {
        this.W = window;
        this.accessid = '';
        this.accesskey = '';
        this.host = 'http://shangkex-test.oss-cn-hangzhou.aliyuncs.com';
        this.policyBase64 = '';
        this.signature = '';
        this.callbackbody = '';
        this.filename = '';
        this.key = '';
        this.expire = 0;
        this.g_object_name = '';
        this.dir = options.dir;
        this.g_object_name_type = options.filenameType || 'local_name'; // random_name
        this.now = this.timestamp = Date.parse(new Date().toString()) / 1000;
        this.env = this._getActiveENV();
        this.browse_button = options.browse_button || 'selectfiles';
        this.multi_selection = options.multi_selection || false;
        this.container = options.container || 'container';
        this.filters = options.filters || {};
        this.filesAry = [];
        this._init();
    }

    async upload(filename?: string) {
        this.filesAry = [];
        const newFilename = filename ? filename.replace(/\s/g, '') : undefined;
        await this._set_upload_param(this.uploader, newFilename || '', false);
        return new Promise(resolve => {
            this.callBackResolve = resolve;
        });
    }

    async uploadBase64(img: string, filename?: string) {
        if (!img || !img.split(';') || img.split(';').length < 2) {
            return;
        }
        this.addBase64(img, filename);
        await this._set_upload_param(this.uploader, filename || '', false);
        return new Promise(resolve => {
            this.callBackResolve = resolve;
        });
    }

    addBase64(img: string, filename?: string) {
        const block = img.split(';');
        const contentType = block[0].split(':')[1]; // In this case "image/gif"
        const realData = block[1].split(',')[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
        const blob = this._b64toBlob(realData, contentType);
        const file = new File([blob], `${filename}.${contentType.split('/')[1]}`, {
            type: contentType,
        });
        this.uploader.addFile(file);
    }

    addFile(file: any) {
        this.uploader.addFile(file);
    }

    async uploadFileObj(file: any) {
        if (!file) {
            return;
        }
        this.filesAry = [];
        this.uploader.addFile(file);
        await this._set_upload_param(this.uploader, file.name || '', false);
        return new Promise(resolve => {
            this.callBackResolve = resolve;
        });
    }

    async removeFile(file: any) {
        // 移除上传文件
        this.uploader.removeFile(file);
    }

    private _send_request() {
        let xmlhttp = null;
        if (this.W.XMLHttpRequest) {
            xmlhttp = new XMLHttpRequest();
        } else if (this.W.ActiveXObject) {
            xmlhttp = new this.W.ActiveXObject('Microsoft.XMLHTTP');
        }

        if (xmlhttp !== null) {
            const serverUrl = `https://${this.env}apigateway.gaodun.com/newoss?dir=${this.dir}`;

            xmlhttp.open('GET', serverUrl, false);
            xmlhttp.send(null);
            return JSON.parse(xmlhttp.responseText || '');
        }
        message.warning('Your browser does not support XMLHTTP.');
    }

    private _getActiveENV() {
        const env = environment.getApiEnv();
        return env;
        // const hostname = this.W.location.hostname;
        // if (hostname.indexOf('dev') > -1 || hostname.indexOf('localhost') > -1 || hostname.indexOf('192.168.') > -1) {
        //     return 't-';
        // }
        // if (hostname.indexOf('t-') > -1) {
        //     return 't-';
        // }
        // if (hostname.indexOf('pre-') > -1) {
        //     return 'pre-';
        // }
        // return '';
    }

    private _getBaseUrl() {
        if (this.env === '') {
            return 'https://simg01.gaodunwangxiao.com/';
        }
        return `${this.host}/`;
    }

    private async _get_signature() {
        // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下，3s 作为缓冲。
        this.now = this.timestamp = Date.parse(new Date().toString()) / 1000;
        if (this.expire < this.now + 3) {
            const res = await this._send_request();
            if (!res) {
                return message.error('获取授权错误');
            }
            const { host, policy, accessid, signature, expire, callback, dir } = res;
            this.host = host.replace('http:', window.location.protocol);
            this.policyBase64 = policy;
            this.accessid = accessid;
            this.signature = signature;
            this.expire = parseInt(expire);
            this.callbackbody = callback;
            this.key = dir;
            this.baseUrl = this._getBaseUrl();
            return true;
        }
        return false;
    }

    private _random_string(len: number) {
        const newLen = len || 32;
        const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        const maxPos = chars.length;
        let pwd = '';
        for (let i = 0; i < newLen; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }

    private _get_suffix(filename: string) {
        const pos = filename.lastIndexOf('.');
        let suffix = '';
        if (pos !== -1) {
            suffix = filename.substring(pos);
        }
        return suffix;
    }

    private _calculate_object_name(filename: string) {
        if (this.g_object_name_type === 'local_name') {
            this.g_object_name = `${this.g_object_name}${'#{filename}'}`;
        } else if (this.g_object_name_type === 'random_name') {
            const suffix = this._get_suffix(filename);
            this.g_object_name = this.key + filename.replace(suffix, '.') + this._random_string(10) + suffix;
        }
        return '';
    }

    private _get_uploaded_object_name(filename: string) {
        if (this.g_object_name_type === 'local_name') {
            let tmp_name = this.g_object_name;
            tmp_name = tmp_name.replace('#{filename}', filename);
            return tmp_name;
        } else if (this.g_object_name_type === 'random_name') {
            return this.g_object_name;
        }
    }

    private async _set_upload_param(up: any, filename: string, ret: any) {
        if (ret === false) {
            await this._get_signature();
        }

        this.g_object_name = this.key;
        if (filename !== '') {
            this._calculate_object_name(filename);
        }
        const new_multipart_params = {
            key: this.g_object_name,
            policy: this.policyBase64,
            OSSAccessKeyId: this.accessid,
            success_action_status: '200', // 让服务端返回200,不然，默认会返回204
            callback: this.callbackbody,
            signature: this.signature,
        };
        up.setOption({
            url: this.host,
            multipart_params: new_multipart_params,
        });

        up.start();
    }

    private _b64toBlob(b64Data: string, contentType?: string, sliceSize?: number) {
        const _contentType = contentType || '';
        const _sliceSize = sliceSize || 512;

        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += _sliceSize) {
            const slice = byteCharacters.slice(offset, offset + _sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: _contentType });
    }

    private _init() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this;
        this.uploader = new plupload.Uploader({
            runtimes: 'html5,flash,silverlight,html4',
            browse_button: _this.browse_button,
            multi_selection: _this.multi_selection,
            container: document.getElementById(_this.container || 'container'),
            url: 'http://oss.aliyuncs.com',
            filters: {
                mime_types: [
                    // 只允许上传图片和zip文件
                    { title: 'Image files', extensions: 'jpg,jpeg,gif,png,bmp' },
                    { title: 'Zip files', extensions: 'zip,rar' },
                    { title: 'audio files', extensions: 'mp3,mp4' },
                ],
                max_file_size: '300mb', // 最大只能上传10mb的文件
                prevent_duplicates: false, // 不允许选取重复文件
                ..._this.filters,
            },

            init: {
                PostInit: function () {
                    // console.log('');
                },

                BeforeUpload: function (up: any, file: any) {
                    _this._set_upload_param(up, file.name, true);
                },

                FileUploaded: function (up: any, file: any, info: any) {
                    const filename = _this._get_uploaded_object_name(file.name);
                    switch (+info.status) {
                        case 200:
                            switch (_this.env) {
                                case 't-':
                                    return _this.filesAry.push(`https://t-img01.gaodunwangxiao.com/${filename}`);
                                case 'pre-':
                                    return _this.filesAry.push(`https://pre-img01.gaodunwangxiao.com/${filename}`);
                                default:
                                    return _this.filesAry.push(`https://simg0${randomNumber(1, 5, true)}.gaodunwangxiao.com/${filename}`);
                            }
                        case 203:
                            message.error('上传到OSS成功，但是oss访问用户设置的上传回调服务器失败，失败原因是:' + info.response);
                            break;
                        default:
                            message.error(info.response);
                            break;
                    }
                    _this.callBackResolve(null);
                },
                UploadComplete: function () {
                    _this.callBackResolve(_this.filesAry);
                },
                FileFiltered: function () {
                    // console.log('');
                },
                Error: function (up: any, err: any) {
                    switch (+err.code) {
                        case -600:
                            message.warning('文件过大，请重新选择');
                            break;
                        case -601:
                            message.warning('文件类型不正确');
                            break;
                        case -602:
                            message.warning('文件重复');
                            break;
                        default:
                            message.warning('Error xml:' + err.response);
                    }
                },
            },
        });
        this.uploader.init();
    }
}

export default AliOssUpload;
